import * as React from "react";
import { NavMenu } from "./NavMenu";
import { connect } from "react-redux";
import { ApplicationState } from "../store";
import * as MeState from "../store/Me";
import * as Auth0State from "../store/Auth0";

type OwnProps = {
  children?: React.ReactNode;
};

type Props = {
  me: MeState.MeState;
  auth0: Auth0State.Auth0State;
} & OwnProps;

class LayoutComponent extends React.Component<Props, {}> {
  public render() {
    return (
      <div className="container-fluid max-h-screen overflow-auto">
        <div className="row h-full">
          <div className="col-sm-3 !pl-0 h-screen">
            <NavMenu />
          </div>

          <div className="col-sm-9 max-h-screen overflow-scroll">
            {this.props.children}
            <p />
            &nbsp;
            <p />
          </div>
        </div>
      </div>
    );
  }
}

export const Layout = connect<
  { me: MeState.MeState; auth0: Auth0State.Auth0State },
  {},
  OwnProps,
  ApplicationState
>((state) => ({
  me: state.me,
  auth0: state.auth0,
}))(LayoutComponent);
